import React, { Component, Fragment } from 'react'

class MahasiswaKartu extends Component {
    render() {
        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p className="abu" style={{
                                fontSize: '15px', fontWeight: 'bold', color: '#999999',
                                textTransform: 'capitalize'
                            }}>
                                Akademik&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Cetak Kartu Ujian
                            </p>
                        </div>
                    </div>
                </div>

                <div className="card card-custom mb-3 pl-3 pr-3">
                    <div className="card-body">
                        <form onSubmit={this.caridata}>
                            <div className="row">
                                <div className="col-md-4 mb-2 mt-2">
                                    <select className="form-control selectCust" id="" required>
                                        <option value="">- tahun akademik -</option>
                                    </select>
                                </div>
                                <div className="col-md-4 mb-2 mt-2">
                                    <select className="form-control selectCust" id="" required>
                                        <option value="">- semester -</option>
                                    </select>
                                </div>
                                <div className="col-md-4 mb-2 mt-2">
                                    <select className="form-control selectCust" id="" required>
                                        <option value="">- prodi -</option>
                                    </select>
                                </div>
                                <div className="col-md-4 mb-2 mt-2">
                                    <select className="form-control selectCust" id="" required>
                                        <option value="">- angkatan -</option>
                                    </select>
                                </div>
                                <div className="col-md-4 mb-2 mt-2">
                                    <select className="form-control selectCust" id="" >
                                        <option value="">- jalur -</option>
                                    </select>
                                </div>
                                <div className="col-md-4 mb-2 mt-2">
                                    <p align="right">
                                        <button className="btn btn-success btn-md" >
                                            Cari
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div >

                {/* akan tampil jika filter diatasnya sudah terpenuhi */}
                <div className="card card-custom mb-3 pl-3 pr-3">
                    <div className="card-body">
                        <form onSubmit={this.caridata}>
                            <div className="row">
                                <div className="col-md-4 mb-2 mt-2">
                                    <label>Waktu Cetak</label>
                                    <input type="date" className='form-control'></input>
                                </div>
                            </div>
                        </form>
                        <div className='col-lg-12 mt-2 mb-2'>
                            <p align="right">
                                <button className="btn btn-success" >
                                    Set Tanggal
                                </button>
                            </p>
                        </div>
                    </div>
                </div >
                {/* akan tampil jika filter diatasnya sudah terpenuhi */}


                <div className="card card-custom">
                    <div className="card-body">
                        <p className="card-title text-center" style={{ fontSize: '25px', marginTop: '10px' }}>Data Mahasiswa</p>

                        <div className="table-responsive mt-3">
                            <table id="cekKrs" className="display expandable-table table-striped" style={{ width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>NIM</th>
                                        <th>Nama Mahasiswa</th>
                                        <th>Semester</th>
                                        <th>Aksi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>xx</td>
                                        <td>xx</td>
                                        <td>xx</td>
                                        <td>
                                            <div className="dropdown">
                                                <button className="btn btn-primary dropdown-toggle"
                                                    style={{ padding: '10px', borderRadius: '5px' }}
                                                    type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    Cetak
                                                </button>
                                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a className="dropdown-item" href="#"  ><i className="fa fa-credit-card" />&nbsp;&nbsp;Kartu UTS</a>
                                                    <a className="dropdown-item" href="#"  ><i className="fa fa-credit-card" />&nbsp;&nbsp;Kartu UAS</a>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <br />
                        </div>
                    </div>
                </div>



            </Fragment>

        )
    }
}

export default MahasiswaKartu
